import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LanguageSwitcher } from '@/components/LanguageSwitcher';
import { ThemeToggle } from '@/components/ThemeToggle';

// The in-page section ids the nav jumps to. Written as `/#id` rather than `#id`
// so the links still work from /privacy and /terms, where the target section is
// on a different route.
const SECTIONS = ['features', 'apps', 'plans', 'faq'] as const;

export const SiteHeader: React.FC = () => {
    const { t } = useTranslation();
    const { pathname, hash } = useLocation();
    const [open, setOpen] = useState(false);

    // The mobile nav is an overlay; leaving it open across a navigation would
    // cover the page you just asked for.
    useEffect(() => { setOpen(false); }, [pathname, hash]);

    return (
        <header className="sitehead">
            <div className="wrap sitehead__inner">
                <Link className="brand" to="/">
                    <span className="brand__mark" aria-hidden="true">🚌</span>
                    Bus Line Recorder
                </Link>

                <button
                    type="button"
                    className="iconbtn navtoggle"
                    aria-expanded={open}
                    aria-controls="sitenav"
                    onClick={() => setOpen((v) => !v)}
                >
                    <span aria-hidden="true">☰</span>
                    <span>{t('web.nav.menu')}</span>
                </button>

                {/* `hidden` is toggled only for the mobile overlay; the desktop rule
                    in global.css ignores it because the element is laid out inline. */}
                <nav id="sitenav" className="sitenav" hidden={!open}>
                    {SECTIONS.map((id) => (
                        <Link key={id} className="sitenav__link" to={`/#${id}`}>
                            {t(`web.nav.${id}`)}
                        </Link>
                    ))}
                    <Link className="sitenav__link" to="/#contact">{t('web.nav.contact')}</Link>
                </nav>

                <div className="sitehead__tools">
                    <LanguageSwitcher />
                    <ThemeToggle />
                </div>
            </div>
        </header>
    );
};
